import axios from "axios"
import { HEADERS } from "../../../../../API/UrlAndPaths"
import store from "../../../../../Redux/store"
import { setBillLoading, setDialogBox, setErrorSnack, setOrderIdInPOS, setSingleOrderInfo, setSnackMsg, setSuccessSnack } from "../Slice/billingScreenSlice"
import { setBtnSelected, setCustomer, setCustomerWallet, setOngoingOrderCount } from "../Components/topBarSliceBilling"
import { setReceiptData } from "../Slice/viewOrdersBillingSlice"
import { setAuthPassword } from "../newBillingSlice"
import { setPosReceiptSlice } from "../../../Settings/posReceipt/posReceiptSlice"
import syncEngine from "../../../../../offline/syncEngine"
import db from "../../../../../offline/db"
import offlineManager from "../../../../../offline/offlineManager"



// final placeOrder in payment
export const finalPaymentPOSApiCall=async(body,clearFn,errorClearPayment,onPaymentSuccess,onPaymentFailed)=>{
    store.dispatch(setBillLoading(true))

    // Ensure orderId is present: derive from Redux singleOrderInfo if not in body
    try {
        const state = store.getState();
        const fallbackOrderId = state?.billingScreenSlice?.orderIdForPos || state?.billingScreenSlice?.singleOrderInfo?._id;
        if (!body.orderId && fallbackOrderId) {
            body = { ...body, orderId: fallbackOrderId };
            console.log('💡 Filled missing orderId from Redux:', fallbackOrderId);
        }
        if (!body.orderId) {
            console.error('❌ finalPaymentPOSApiCall: Missing orderId in payload and Redux');
            store.dispatch(setBillLoading(false));
            store.dispatch(setSnackMsg('Payment failed: missing order ID'));
            store.dispatch(setErrorSnack(true));
            onPaymentFailed && onPaymentFailed();
            return;
        }
        
        // Check if this is an offline order (UUID format)
        // For offline orders, process payment locally and queue for sync
        if (syncEngine.isOfflineOrderId(body.orderId)) {
            console.log('📴 Offline order detected - processing payment locally:', body.orderId);
            
            try {
                // Update the offline order's payment status in IndexedDB
                const updatedOrder = await db.updateOfflineOrder(body.orderId, {
                    isPaid: true,
                    paymentStatus: 'PAID',
                    ordStatus: 'COMPLETED',
                    paymentDetails: body.paymentMethod || body.paymentDetails || [],
                    onGoing: 0
                });
                
                if (updatedOrder) {
                    console.log('✅ Updated offline order payment status:', body.orderId);
                    
                    // Queue the payment for sync when online
                    const queueResult = await offlineManager.queueTransaction({
                        method: 'POST',
                        url: 'pos/postPosPayment',
                        data: body,
                        headers: HEADERS
                    });
                    console.log('✅ Payment queued for sync:', queueResult.transactionId);
                    
                    // Generate KOT data from offline order for printing
                    // kotData should be an ARRAY of KOT objects for the receipt print logic
                    const kotToken = updatedOrder.kotInfo?.[0] || updatedOrder.transNo || '1';
                    const kotDataArray = [{
                        name: `${kotToken}`,
                        ordName: updatedOrder.ordName || updatedOrder.name,
                        orderDate: updatedOrder.orderDate,
                        ordType: updatedOrder.ordType,
                        waiterName: updatedOrder.waiterName || '-NIL-',
                        orderInfo: updatedOrder.orderInfo || [],
                        tables: updatedOrder.tableNames || [],
                        floorName: updatedOrder.floorName || '',
                        transNo: kotToken
                    }];
                    console.log('🎫 Generated KOT data array for offline order:', kotDataArray);
                    
                    // Success - notify and clear
                    onPaymentSuccess && onPaymentSuccess();
                    await new Promise(resolve => setTimeout(resolve, 500));
                    
                    store.dispatch(setOrderIdInPOS(null));
                    store.dispatch(setCustomer(null));
                    store.dispatch(setSnackMsg("Payment Successful (Offline) 👍"));
                    store.dispatch(setSuccessSnack(true));
                    store.dispatch(setAuthPassword(""));
                    store.dispatch(setBillLoading(false));
                    clearFn();
                    
                    // Build paymentInfo for receipt (backend returns this for online orders)
                    // body.paymentMethod = [{type, paidAmt, ...}], receipt expects [{type, amount}]
                    const paymentInfo = (body.paymentMethod || []).map(pm => ({
                        type: pm.type || 'cash',
                        amount: Number(pm.paidAmt) || 0
                    }));

                    // Get receipt from the updated order with kotData and show print dialog
                    const receiptDataWithKot = {
                        ...updatedOrder,
                        kotData: kotDataArray,
                        paymentInfo: paymentInfo
                    };
                    store.dispatch(setReceiptData(receiptDataWithKot));
                    
                    // Ensure POS receipt template is loaded from localStorage for offline
                    const localTemplate = localStorage.getItem('posReceiptTemplate');
                    if (localTemplate) {
                        console.log('🧾 Offline payment: Using localStorage template:', localTemplate);
                        store.dispatch(setPosReceiptSlice({ posReceiptTemplate: Number(localTemplate) }));
                    }
                    
                    // Show invoice print dialog for offline receipt
                    store.dispatch(setDialogBox("invoicePrint"));
                    
                    store.dispatch(setBtnSelected(null));
                    store.dispatch(setOngoingOrderCount(0));
                    return; // Exit early - don't make axios call
                } else {
                    console.error('❌ Offline order not found:', body.orderId);
                    store.dispatch(setBillLoading(false));
                    store.dispatch(setSnackMsg('Order not found'));
                    store.dispatch(setErrorSnack(true));
                    onPaymentFailed && onPaymentFailed();
                    return;
                }
            } catch (offlineError) {
                console.error('❌ Error processing offline payment:', offlineError);
                store.dispatch(setBillLoading(false));
                store.dispatch(setSnackMsg('Payment failed: ' + offlineError.message));
                store.dispatch(setErrorSnack(true));
                onPaymentFailed && onPaymentFailed();
                return;
            }
        }
    } catch (syncError) {
        console.error('❌ Error during order sync check:', syncError);
    }

    await axios.post("pos/postPosPayment",body,HEADERS)
        .then(async (res)=>{
            // Handle both online (200) and offline (202) responses
            if(res.status===200 || res.status===202){
                const isOffline = res.status === 202 || res.headers?.['x-offline'] === 'true';
                
                // IMPORTANT: Notify customer display FIRST before clearing cart
                // This ensures the success message is sent before cart is cleared
                onPaymentSuccess && onPaymentSuccess();
                
                // Longer delay to ensure socket emit happens before cart clear
                // The socket needs time to emit the success status to customer display
                await new Promise(resolve => setTimeout(resolve, 500));
                
                store.dispatch(setOrderIdInPOS(null))                
                store.dispatch(setCustomer(null))                
                store.dispatch(setSnackMsg(isOffline ? "Payment Successful (Offline)" : "Payment Succesfull 👍"))
                store.dispatch(setSuccessSnack(true))
                store.dispatch(setAuthPassword(""))
                store.dispatch(setDialogBox(null))        
                clearFn()
                
                // getInvoiceReceipt works both online and offline:
                // - Online: fetches from backend
                // - Offline: axios interceptor serves from IndexedDB cache
                await getInvoiceReceipt({orderId:res.data?._id})
                
                store.dispatch(setBtnSelected(null))
                store.dispatch(setOngoingOrderCount(res?.data?.onGoing || 0))

            }
        })
        .catch((err)=>{
            errorClearPayment()
            // Notify customer display of payment failure
            onPaymentFailed && onPaymentFailed();
            let message=err.response?.status===500?"Internal Server Error !!":err.response?.status===400?"Wrong payload passed":err.response?.data || err.message
            store.dispatch(setSnackMsg(message))
            store.dispatch(setBillLoading(false))                
            store.dispatch(setErrorSnack(true))
        })
}
// refund in payment
export const refundPaymentApiCall=async(body,clearFn)=>{
    store.dispatch(setBillLoading(true))

    await axios.post("pos/refundAndReturnOrd",body,HEADERS)
        .then((res)=>{
            if(res.status===200){
                store.dispatch(setOrderIdInPOS(null))                
                store.dispatch(setSingleOrderInfo(null))                
                store.dispatch(setBillLoading(false))                
                store.dispatch(setBtnSelected(null))                
                store.dispatch(setSnackMsg("Refund Succesfull 👍"))
                store.dispatch(setSuccessSnack(true))
                store.dispatch(setCustomer(null))                
                clearFn()
            }
        })
        .catch((err)=>{
            let message=err.response.status===500?"Internal Server Error !!":err.response.data
            store.dispatch(setSnackMsg(message))
            store.dispatch(setBillLoading(false))                
            store.dispatch(setErrorSnack(true))
        })
}
// refund update payment
export const refundUpdatePaymentApiCall=async(body,clearFn)=>{
    store.dispatch(setBillLoading(true))
    await axios.post("pos/returnOrderPayment",body,HEADERS)
        .then((res)=>{
            if(res.status===200){
                clearFn()
                store.dispatch(setOrderIdInPOS(null))                
                store.dispatch(setSingleOrderInfo(null))                
                store.dispatch(setBillLoading(false))                
                store.dispatch(setBtnSelected("viewOrder"))                
                store.dispatch(setSnackMsg("Refund Succesfull 👍"))
                store.dispatch(setSuccessSnack(true))           
            }
        })
        .catch((err)=>{
            let message=err.response.status===500?"Internal Server Error !!":err.response.data
            store.dispatch(setSnackMsg(message))
            store.dispatch(setBillLoading(false))                
            store.dispatch(setErrorSnack(true))
        })
}


export const getCustomerWallet=async(body)=>{
    await axios.post("pos/viewCustomerWallet",body,HEADERS)
        .then((res)=>{
            if(res.status===200){
                store.dispatch(setCustomerWallet(res.data))
            }
        })
        .catch((err)=>{
            store.dispatch(setCustomerWallet(null))
        })
}


export const getInvoiceReceipt=async(body)=>{
    await axios.post("pos/viewPosOrderForInvoice",body,HEADERS)
        .then((res)=>{
            // Handle both online (200) and offline (202) responses
            if(res.status===200 || res.status===202){
                const isOffline = res.status === 202 || res.headers?.['x-offline'] === 'true';
                let pageInfo=store.getState().topBarSliceBilling.btnClicked;

                console.log(`Receipt Data Received${isOffline ? ' (offline)' : ''}:`, res.data);
                // Use receipt data as-is from backend/cache - delivery charge already correct
                store.dispatch(setReceiptData(res.data))
                
                // Ensure POS receipt template is loaded with localStorage priority
                const localTemplate = localStorage.getItem('posReceiptTemplate');
                console.log('🔍 getInvoiceReceipt: localStorage posReceiptTemplate =', localTemplate);
                if (localTemplate) {
                    console.log('🎯 getInvoiceReceipt: Using localStorage template as priority:', localTemplate);
                    store.dispatch(setPosReceiptSlice({ posReceiptTemplate: Number(localTemplate) }));
                } else {
                    console.log('⚠️ getInvoiceReceipt: No template found in localStorage');
                }
                
                store.dispatch(setBillLoading(false))      
                !(pageInfo==="viewOrder" || pageInfo==="heldOrder") && store.dispatch(setDialogBox("invoicePrint"))          
            }
        })
        .catch((err)=>{
            console.error("Error fetching invoice receipt:", err);
            store.dispatch(setSnackMsg("Failed to fetch invoice data"))
            store.dispatch(setErrorSnack(true))
            store.dispatch(setReceiptData(null))
            store.dispatch(setBillLoading(false))
        })
}
export const deliveryReceiptInfo=async(body)=>{
    await axios.post("pos/viewPosOrderForInvoice",body,HEADERS)
        .then((res)=>{
            // Handle both online (200) and offline (202) responses
            if(res.status===200 || res.status===202){
                const isOffline = res.status === 202 || res.headers?.['x-offline'] === 'true';
                console.log(`Delivery Receipt Data Received${isOffline ? ' (offline)' : ''}:`, res.data);
                // Use receipt data as-is from backend/cache - delivery charge already correct
                store.dispatch(setReceiptData(res.data))
                
                // Ensure POS receipt template is loaded with localStorage priority
                const localTemplate = localStorage.getItem('posReceiptTemplate');
                console.log('🔍 deliveryReceiptInfo: localStorage posReceiptTemplate =', localTemplate);
                if (localTemplate) {
                    console.log('🎯 deliveryReceiptInfo: Using localStorage template as priority:', localTemplate);
                    store.dispatch(setPosReceiptSlice({ posReceiptTemplate: Number(localTemplate) }));
                } else {
                    console.log('⚠️ deliveryReceiptInfo: No template found in localStorage');
                }
                
                store.dispatch(setBillLoading(false))      
                store.dispatch(setDialogBox("deliveryPrint"))          
            }
        })
        .catch((err)=>{
            store.dispatch(setSnackMsg("Failed to fetch receipt data!!"))
            store.dispatch(setErrorSnack(true))
            store.dispatch(setReceiptData(null))
        })
}